import { combineReducers } from 'redux';
import labels from './labels';
import cruise from './cruise';
import searchInformation from './searchInformation';
import transport from './transport';
import accommodation from './accommodation';
import message from './message';

const cabinListApp = (common) => {
  return combineReducers({
    labels,
    cruise,
    common,
    searchInformation,
    transport,
    accommodation,
    message,
  });
};

export default cabinListApp;
